export default __webpack_public_path__ + "static/media/continue.ff67371d.png";